<template>
  <div class="container pick-up-time__wrapper">
    <div class="ws-textbox">
      <div class="text-center">Choose a pick up time</div>
      <div class="show-hour text-center">
        {{ data[0] + ':' + data[1] }}
      </div>
      <div class="mb-3">
        <smooth-picker v-show="showPicker" ref="smoothPicker" :data="dataHour" :change="dataChange" />
      </div>
      <div class="text-center">
        <button class="btn btn-confirm" @click="confirmPickUpTime()">Confirm</button>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from 'lodash'
export default {
  name: 'PopupPickTime',
  props: {
    idModal: {
      type: String,
      default: ''
    },
    timePickup: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showPicker: false,
      dataHour: [
        {
          currentIndex: 0,
          flex: 3,
          list: _.range(24),
          // onClick: this.clickOnGender,
          textAlign: 'center',
          className: 'row-group'
        },
        {
          currentIndex: 0,
          flex: 3,
          list: _.range(0, 60, 5),
          // onClick: this.clickOnGender,
          textAlign: 'center',
          className: 'row-group'
        }
      ],
      data: ['00', '00']
    }
  },
  created() {
    // fill time = now + 30 minutes, get from Taxi2Ride
    this.$set(this.data, 0, this.timePickup['HH'])
    this.$set(this.data, 1, this.timePickup['mm'])
    this.$set(this.dataHour[0], 'currentIndex', Number(this.timePickup['HH']))
    this.$set(this.dataHour[1], 'currentIndex', Number(this.timePickup['mm']) / 5)
  },
  mounted() {
    setTimeout(() => {
      this.showPicker = true
    }, 0)
    for (let [index, data] of this.dataHour.entries()) {
      data.list = this.formatDataTime(data.list)
      this.$set(this.dataHour, index, data)
    }
  },
  methods: {
    getTime(value) {
      const ciList = this.$refs.smoothPicker.getCurrentIndexList()
      return this.dataHour[value].list[ciList[value]]
    },
    // clickOnGender() {
    //   const ciList = this.$refs.smoothPicker.getCurrentIndexList();
    //   window.alert("Clicked index:" + ciList[0]);
    // },
    dataChange(gIndex, iIndex) {
      let value = String(this.dataHour[gIndex].list[iIndex])
      if (value.length == 1) value = '0' + value
      this.$set(this.data, gIndex, value)
    },
    confirmPickUpTime() {
      const ciList = this.$refs.smoothPicker.getCurrentIndexList()
      this.$emit('confirmPickUpTime', {
        HH: this.dataHour[0].list[ciList[0]],
        mm: this.dataHour[1].list[ciList[1]]
      })
    },
    formatDataTime(dataArr) {
      for (let [index, data] of dataArr.entries()) {
        data = String(data)
        if (data.length == 1) {
          this.$set(dataArr, index, '0' + data)
        }
      }
      return dataArr
    }
  }
}
</script>
<style lang="scss">
div[id^='pick-up-time'] {
  .modal-backdrop {
    opacity: 0.5;
    background-color: #000 !important;
  }
  .modal-content {
    background-color: transparent !important;
    border: 0 !important;
  }
}
</style>

<style lang="scss" scoped>
.pick-up-time__wrapper {
  --color-btn-confirm: #0094d5;
  max-width: 350px;
  .ws-textbox {
    color: #777 !important;
  }
  .show-hour {
    font-size: 36px;
  }

  ::v-deep .smooth-item.text-center.smooth-item-selected {
    color: var(--color-btn-confirm);
    font-weight: 500;
    font-size: 21px;
    line-height: 1.5;
  }

  ::v-deep .smooth-picker .smooth-handle-layer .smooth-top {
    background: linear-gradient(180deg, #fff 10%, hsla(0, 0%, 100%, 0));
  }

  ::v-deep .smooth-picker .smooth-handle-layer .smooth-bottom {
    background: linear-gradient(0deg, #fff 10%, hsla(0, 0%, 100%, 0));
  }

  ::v-deep .modal-backdrop {
    opacity: 0.5;
    background-color: #000 !important;
  }

  .btn-confirm {
    background-color: var(--color-btn-confirm);
    color: white;
    padding: 0.575rem 3rem;
    border-radius: 1rem;
  }
}
</style>
